import { nanoid } from "nanoid";
import "remixicon/fonts/remixicon.css";
import Card from "./ProjectsCard";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
export const programs = [
  {
    id: nanoid(),
    title: "Agricultural Training",
    description:
      "Comprehensive training programs covering modern farming techniques, sustainable practices, and crop management for young farmers.",
    image: <i className="ri-seedling-line" style={{ fontSize: "32px", color: "green" }}></i>,
    iconBgColor: "#D0F0E8",
  },
  {
    id: nanoid(),
    title: "Financial Support",
    description:
      "Access to microloans, grants, and financial literacy programs to help youth start and grow their agricultural businesses.",
    image: <i className="ri-funds-line" style={{ fontSize: "32px", color: "#daa40fff" }}></i>
     ,
    iconBgColor: "#FFE9CC",
  },
  {
    id: nanoid(),
    title: "Technology Integration",
    description:
      "Training on agricultural technology, mobile apps for farm management, and digital tools to increase productivity and market access.",
    image: <i className="ri-smartphone-line" style={{ fontSize: "32px", color: "#3a86ff" }}></i>,
    iconBgColor: "#D5E8F7",
  },
  {
    id: nanoid(),
    title: "Community Building",
    description:
      "Creating networks of young farmers for knowledge sharing, collaboration, and collective marketing of agricultural products.",
    image: <i className="ri-team-line" style={{ fontSize: "32px", color: "#3f37c9" }}></i>,
    iconBgColor: "#EBD9F5",
  },
]

export const programsCardsGenerator = (programs)=>{
    return programs?.map((program) => (
    <div key={program.id} className="program-card">
      <div
        className="program-icon-wrapper"
        style={{ backgroundColor: program.iconBgColor }}
      >
        {program.image}
      </div>
      <h3 className="program-title">{program.title}</h3>
      <p className="program-description">{program.description}</p>
    </div>
  ));
}

export const aboutPageContent = [
  {
    id: nanoid(),
    title: "Contract Farming for the ABC Market",
    description:"By engaging in contract farming, we help young farmers to reduce risks associated with price fluctuations and market uncertainties, providing them with stable income opportunities since we guarantee them uptake of their produce in our stores.",
    image: <i className="ri-seedling-line" style={{ fontSize: "32px", color: "green" }}></i>,
    iconBgColor: "#D0F0E8",
  },
  {
    id: nanoid(),
    title: "Financial Support to Farmers",
    description:"Most farmers especially the Youth and women have great ideas to produce from their farms. These great ideas never come to fruition due to lack of capital. It is on this background that we came up with a Credit Finance to bridge this gap for our members in order to ensure we have an uninterrupted production for our ABC Market demand.",
    image: <i className="ri-seedling-line" style={{ fontSize: "32px", color: "green" }}></i>,
    iconBgColor: "#D0F0E8",
  },
]

export const aboutPageValues = [
   {
    id: nanoid(),
    title: "Quality Products",
    description:"We are a reliable partner of choice for delivery of quality & healthy produce to meet increasing consumer demands and achieve food security.",
    image: <i className="ri-seedling-line" style={{ fontSize: "32px", color: "green" }}></i>,
    iconBgColor: "#D0F0E8",
  },
  {
    id: nanoid(),
    title: "Perfect Service",
    description:"We connect investors around the world with local African farmers to provide a platform for everyone to invest and earn great returns from commercial farming.",
    image: <i className="ri-funds-line" style={{ fontSize: "32px", color: "#daa40fff" }}></i>
     ,
    iconBgColor: "#FFE9CC",
  },
  {
    id: nanoid(),
    title: "100% Natural",
    description:"We have been embracing the idea of organic farming, concerned with health and environment care issues, or striving for new gastronomic experiences.",
    image: <i className="ri-smartphone-line" style={{ fontSize: "32px", color: "#3a86ff" }}></i>,
    iconBgColor: "#D5E8F7",
  },
  {
    id: nanoid(),
    title: "Environmentally friendly",
    description:"Being an environmentally conscious brand we make sure everything our business does is good for the environment.",
    image: <i className="ri-team-line" style={{ fontSize: "32px", color: "#3f37c9" }}></i>,
    iconBgColor: "#EBD9F5",
  },
]

export const projects = [
  {
    id: nanoid(),
    title: "Youth Farmer Cooperatives",
    description:
      "Building networks of young farmers for collective marketing, resource sharing, and community support systems.",
    image: "https://images.unsplash.com/photo-1500382017468-7049fae79138?w=500&h=300&fit=crop",
    participants: "1,500+ Youth",
    duration: "Ongoing",
    location: "East Africa",
    category: "Community",
  },
  {
    id: nanoid(),
    title: "Sustainable Irrigation Systems",
    description:
      "Training on water conservation, drip irrigation, rainwater harvesting, and efficient water management for farms.",
    image: "https://images.unsplash.com/photo-1574943320219-553eb213f72d?w=500&h=300&fit=crop",
    participants: "450+ Youth",
    duration: "2 Months",
    location: "West Africa",
    category: "Training",
  },
  {
    id: nanoid(),
    title: "Drone Technology for Agriculture",
    description:
      "Introduction to using drones for crop monitoring, pest detection, and precision agriculture applications.",
    image: "https://images.unsplash.com/photo-1574259741362-e9d6d3e39c4a?w=500&h=300&fit=crop",
    participants: "200+ Youth",
    duration: "1 Month",
    location: "East Africa",
    category: "Technology",
  },
  {
    id: nanoid(),
    title: "Poultry Farming Enterprise",
    description:
      "Complete training on starting and managing profitable poultry farms, including housing, feeding, and disease management.",
    image: "https://images.unsplash.com/photo-1598103442097-8b74394b95c6?w=500&h=300&fit=crop",
    participants: "700+ Youth",
    duration: "5 Months",
    location: "East Africa",
    category: "Training",
  },
  {
    id: nanoid(),
    title: "Agricultural Loan Program",
    description:
      "Low-interest loans for young farmers to purchase equipment, seeds, and livestock to start or expand their farms.",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=500&h=300&fit=crop",
    participants: "900+ Youth",
    duration: "Ongoing",
    location: "West Africa",
    category: "Finance",
  },
  {
    id: nanoid(),
    title: "Women in Agriculture Initiative",
    description:
      "Special program empowering young women farmers with skills, resources, and mentorship for agricultural success.",
    image: "https://images.unsplash.com/photo-1542601906960-ba2006ce398d?w=500&h=300&fit=crop",
    participants: "1,100+ Women",
    duration: "Ongoing",
    location: "East Africa",
    category: "Community",
  },
  {
    id: nanoid(),
    title: "Modern Farming Techniques Training",
    description:
      "Comprehensive 6-month program teaching sustainable farming practices, crop rotation, soil management, and organic farming methods.",
    image: "https://images.unsplash.com/photo-1560493676-04071c5f467b?w=500&h=300&fit=crop",
    participants: "1,200+ Youth",
    duration: "6 Months",
    location: "East Africa",
    category: "Training",
  },
  {
    id: nanoid(),
    title: "AgriTech Mobile App Training",
    description:
      "Learn to use mobile applications for farm management, weather forecasting, pest control, and connecting with buyers and suppliers.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=300&fit=crop",
    participants: "800+ Youth",
    duration: "3 Months",
    location: "West Africa",
    category: "Technology",
  },
  {
    id: nanoid(),
    title: "Microfinance & Business Skills",
    description:
      "Access to microloans, financial literacy training, business planning, and entrepreneurship skills for agricultural ventures.",
    image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=500&h=300&fit=crop",
    participants: "600+ Youth",
    duration: "4 Months",
    location: "East Africa",
    category: "Finance",
  },
]


export const filteredSection = (filteredPrograms)=>{
  return filteredPrograms.map((program) => (
            <Card key={program.id} program={program} />
          ))
}

export const convertToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}


export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}


//  importing service titles fetch function


export const fetchServiceTitles = async () => {
    try {
      const apiUrl = process.env.REACT_APP_API_URL 
      const response = await axios.get(`${apiUrl}/services/get-titles`,{ withCredentials: true });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch service titles:", error);
    }
  }
